import {adminManagementTableRow} from "./types/index"

export const mockAdminManagementData: adminManagementTableRow[] = [
  {
    initials: "DC",
    fullName: "ADMIN_MANAGEMENT.EMPLOYEES.DAVID_COHEN.fullName",
    role: "ADMIN_MANAGEMENT.ROLES.ADMIN",
    phone: "050-1234567",
    mail: "david.cohen@silagi.com",
    department: "ADMIN_MANAGEMENT.DEPARTMENTS.MANAGEMENT",
    status: "ACTIVE",
    departureDate: "2026-07-10T09:30:00",
  },
  {
    initials: "SL",
    fullName: "ADMIN_MANAGEMENT.EMPLOYEES.SARAH_LEVI.fullName",
    role: "ADMIN_MANAGEMENT.ROLES.PRODUCTION_MANAGER",
    phone: "052-2345678",
    mail: "sarah.levi@silagi.com",
    department: "ADMIN_MANAGEMENT.DEPARTMENTS.PRODUCTION",
    status: "ACTIVE",
    departureDate: "2026-07-12T14:05:00",
  },
  {
    initials: "MF",
    fullName: "ADMIN_MANAGEMENT.EMPLOYEES.MOSHE_FRIEDMAN.fullName",
    role: "ADMIN_MANAGEMENT.ROLES.TECHNICIAN",
    phone: "054-3456789",
    mail: "moshe.friedman@silagi.com",
    department: "ADMIN_MANAGEMENT.DEPARTMENTS.ENGINEERING",
    status: "NOT_ACTIVE",
    departureDate: "2026-06-28T11:20:00",
  },
  {
    initials: "RM",
    fullName: "ADMIN_MANAGEMENT.EMPLOYEES.RACHEL_MIZRAHI.fullName",
    role: "ADMIN_MANAGEMENT.ROLES.SALES",
    phone: "053-4567890",
    mail: "rachel.mizrahi@silagi.com",
    department: "ADMIN_MANAGEMENT.DEPARTMENTS.SALES",
    status: "ACTIVE",
    departureDate: "2026-07-13T08:45:00",
  },
  {
    initials: "YA",
    fullName: "ADMIN_MANAGEMENT.EMPLOYEES.YOSEF_AVRAHAM.fullName",
    role: "ADMIN_MANAGEMENT.ROLES.QUALITY_CONTROL",
    phone: "058-5678901",
    mail: "yosef.avraham@silagi.com",
    department: "ADMIN_MANAGEMENT.DEPARTMENTS.QUALITY",
    status: "NOT_ACTIVE",
    departureDate: "2026-05-19T16:10:00",
  },
]
